import Vue from 'vue'
import api from "@/api/api.js";
import { DataLoadState } from "@/utils/storeUtils.js";


// Mutation names
const SET_LOAD_USER_STARTED = "setLoadUserStarted";
const SET_LOAD_USER_FINISHED_SUCCESSFULLY = "setLoadUserFinishedSuccessfully";
const SET_LOAD_USER_FAILED= "setLoadUserFailed";
const CLEAR_CACHE= "clearCache";

// Getter names
export const IS_LOADING_USER_WITH_ID = "isLoadingUserWithId";
export const GET_USER_WITH_ID = "getUserWithId";
export const GET_LOAD_ERROR_FOR_USER_WITH_ID = "getLoadErrorForUserWithId";

// Action name
export const LOAD_USERS_WITH_IDS = "loadUsersWithIds";
export const ADD_USER = "addUser";
export const RESET_USERS_CACHE = "reset";


// Users cache store implementation
export const UsersCacheStore = {
  namespaced: true,

  state: () => ({ // state must be a function to allow reuse of this store
    usersCache: {}
  }),

  mutations: {
    [SET_LOAD_USER_STARTED](state, { userId }) {
      const dataLoadState = new DataLoadState(userId);
      Vue.set(state.usersCache, userId, dataLoadState.stateForLoadStarted());
    },

    [SET_LOAD_USER_FINISHED_SUCCESSFULLY](state, { user }) {
      const dataLoadState = state.usersCache[user.id] || new DataLoadState(user.id);
      Vue.set(state.usersCache, user.id, dataLoadState.stateForLoadFinished(user));
    },

    [SET_LOAD_USER_FAILED](state, { userId, error }) {
      const dataLoadState = state.usersCache[userId];
      Vue.set(state.usersCache, userId, dataLoadState.stateForLoadFailed(error));
    },

    [CLEAR_CACHE](state) {
      state.usersCache = {};
    }
  },

  getters: {
    [IS_LOADING_USER_WITH_ID]: state => userId => {
      const dataLoadState = state.usersCache[userId];
      if (!dataLoadState) {
        return false;
      }

      return dataLoadState.status.loading;
    },

    [GET_USER_WITH_ID]: state => userId => {
      const dataLoadState = state.usersCache[userId];
      if (!dataLoadState) {
        return null;
      }

      return dataLoadState.data;
    },

    [GET_LOAD_ERROR_FOR_USER_WITH_ID]: state => userId => {
      const dataLoadState = state.usersCache[userId];
      if (!dataLoadState) {
        return null;
      }

      return dataLoadState.status.error;
    }
  },

  actions: {
    [LOAD_USERS_WITH_IDS]: async ({ state, commit }, { userIds }) => {
      const filteredUserIds = userIds
        .filter(userId => userId !== null && userId !== undefined)
        .filter(userId => !state.usersCache[userId] || state.usersCache[userId].status.fail === true);

      const uniqueUserIds = [...new Set(filteredUserIds)];

      if (uniqueUserIds.length === 0) {
        return;
      }

      uniqueUserIds.forEach(userId => {
        commit(SET_LOAD_USER_STARTED, { userId });
      });

      try {
        const response = await api.post(`admin/users/load`, { userIds: uniqueUserIds });
        const users = response.data;

        users.forEach(user => {
          commit(SET_LOAD_USER_FINISHED_SUCCESSFULLY, { user });
        });

        // Handle users that were not found
        uniqueUserIds
          .filter(userId => state.usersCache[userId].status.success === false)
          .forEach(userId => {
            commit(SET_LOAD_USER_FINISHED_SUCCESSFULLY, { user: { id: userId, firstName: '[unknown user]', lastName: '' } });
          });
      } catch (error) {
        uniqueUserIds.forEach(userId => {
          commit(SET_LOAD_USER_FAILED, { userId, error });
        });
      }
    },

    [ADD_USER]: async ({ commit }, { user }) => {
      if (!user || !user.id) {
        return;
      }

      commit(SET_LOAD_USER_FINISHED_SUCCESSFULLY, { user });
    },

    [RESET_USERS_CACHE]: async ({ commit }) => {
      commit(CLEAR_CACHE);
    }
  }
}
